<template>
  <b-container class="horaire_form">
    <p>
      Cet évenement n'étant pas un live, il est nécessaire de renseigner les
      heures de départ des différentes courses afin d'autoriser la recherche par dossard.
    </p>
    <div class="sep"></div>
    <b-row
      class="horaire_item_form"
      v-for="(course, index) in horaires"
      :key="index"
    >
    
      <b-col md="3">
        <p><b>{{ course.nom }}</b></p>
      </b-col>
      <b-col md="4" class="horaire_date_form">
        <b-form-datepicker
        size="sm"
          v-model="course.date"
          locale="fr"
        ></b-form-datepicker>
      </b-col >
      <b-col md="5" class="horaire_time_form">
        <b-form-input size="sm"  v-model="course.hours" placeholder="10"></b-form-input> :
        <b-form-input size="sm"  v-model="course.minutes" placeholder="00"></b-form-input> :  
        <b-form-input size="sm"  v-model="course.seconds" placeholder="00"></b-form-input>  
      </b-col>
    </b-row>
    <div class="sep"></div>
    <b-row>
        <b-col>
            <b-button @click="sendHoraires">Sauvegarder les horaires</b-button>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["courses"],
  data() {
    return {
      horaires: [],
    };
  },
  methods : {
    sendHoraires(){
      for(var i  = 0;i<this.horaires.length;i++){
        this.horaires[i].heure = this.horaires[i]["heure"] = this.horaires[i]["hours"]+":"+this.horaires[i]["minutes"]+":"+this.horaires[i]["seconds"];
      }
      this.$emit("updateHoraires",this.horaires);
    }
  },
  created() {
    this.horaires = JSON.parse(JSON.stringify(this.courses));
    for(let i = 0;i<this.horaires.length;i++){
      if(this.horaires[i].date === ""){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        this.horaires[i].date = today;
      }
      if(!this.horaires[i].hours){
        this.horaires[i].hours = "10";
      }
            if(!this.horaires[i].minutes){
        this.horaires[i].minutes = "00";
      }
            if(!this.horaires[i].seconds){
        this.horaires[i].seconds = "00";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.horaire_form {
    padding-top:15px;
    padding-bottom:15px;
    border-radius:0.5rem;
    margin-bottom:30px;
  background-color: white;
  .horaire_item_form {
      margin-top:5px;
      margin-bottom:5px;

    .horaire_time_form{
        input{
            width:60px;
            display:inline;
        }

    }
  }
}
</style>